import {useCallback, useContext} from "react";
import CountryContext from "../CountryContext";
import useCountryAxiosInstance from "./useCountryAxiosInstance";
import {useIntl} from "react-intl";

const useFetchApItems = (serviceId) => {
  const intl = useIntl();
  const { country } = useContext(CountryContext);
  const countryApiRequest = useCountryAxiosInstance(country?.code);

  return useCallback(
    async (parent = null) => {
      if (!parent)
        return await countryApiRequest.get('/price_analysis_items/parents/service/' + serviceId);

      // retrieve children items information in order to use it to produce the final result
      const children = await countryApiRequest
        .get(`/price_analysis_items/${parent.id}/children`)
        .then((result) => result.reduce(
          (acc, curr) => ({...acc, [curr.code]: curr}),
          {}
        ));

      // integrate par_items with children data
      return Object.values(parent.par_items).map(({ name, items }) => ({
        name: name ?? `[${intl.formatMessage({ id: "ungrouped" })}]`,
        items: items?.map(
          ({ code }, idx) =>
            ({
              code: code,
              des_short:
                children[code]?.des_short ??
                intl.formatMessage({ id: "description_not_available" }),
              value: `${idx}|${name}`,
            } ?? [])
        ),
      }));
    },
    [countryApiRequest],
  );
}

export default useFetchApItems;